<template>
	<div class="operator">
		<div class="search">
			<span class="title">采伐者</span>
			<div class="flex">
				<el-input placeholder="请输入关键字" v-model="key" class="flex-sub">
				    <el-select v-model="keywordType" slot="prepend" placeholder="请选择" style="width: 120px;">
				     <el-option label="采伐者" value="1"></el-option>
				     <el-option label="身份证" value="2"></el-option>
				     <el-option label="地址" value="3"></el-option>
				    </el-select>
				</el-input>
				<el-button type="success" @click="getList">搜 索</el-button>
			</div>
		</div>
		<div class="table">
			<el-table :data="tableData" height="700px"  v-loading="loading" element-loading-text="数据加载中..." align="center" :header-cell-style="{background:'#f4f7fe'}">
				<el-table-column prop="name" label="采伐者"></el-table-column>
				<el-table-column prop="idCard" label="身份证/机构代码"></el-table-column>
				<el-table-column prop="address" label="地址"></el-table-column>
				<el-table-column label="操作" align="right">
					<template slot-scope="scope">
						<el-button type="success" size="small" @click="goDetail(scope.row,1)">详情</el-button>
						<el-button type="success" size="small" @click="goDetail(scope.row,2)">伐区列表</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-sizes="[10, 20, 50]"
				layout="sizes, prev, pager, next"
				:total="total"
			></el-pagination>
		</div>
		<!-- 详情对话框 -->
		<el-drawer
		  :title="detailForm.Name+ '详情'"
		  :visible.sync="detailModal"
			size="20%"
			:modal="false"
		  >
				<el-scrollbar style="height: 90%" ref="scrollbar">
				<el-form :model="detailForm" style="padding:10px">
					<el-form-item label="注册类型:" laber-width="120px"><span>{{detailForm.type==1?'企业':'个人'}}</span></el-form-item>
					<el-form-item label="姓名/公司名:" laber-width="120px"><span>{{detailForm.Name}}</span></el-form-item>
					<el-form-item label="联系电话:" laber-width="120px"><span>{{detailForm.Phone}}</span></el-form-item>
					<el-form-item label="唯一编码:" laber-width="120px"><span>{{detailForm.IDCard}}</span></el-form-item>
					<el-form-item label="状态:" laber-width="120px"><span>{{detailForm.State==0?'审核中':detailForm.State==1?'通过审核':'未通过审核'}}</span></el-form-item>
					<el-form-item label="地址:" laber-width="120px"><span>{{detailForm.Address}}</span></el-form-item>
					<el-form-item label="城镇:" laber-width="120px"><span>{{detailForm.TownName}}</span></el-form-item>
					<el-form-item label="创建时间:" laber-width="120px"><span>{{detailForm.CreationTime}}</span></el-form-item>
					
					<!-- 					
					<el-form-item label="身份证照(前):" laber-width="120px">
						<showImages v-if="detailForm.IDCardImageTops2&&detailForm.IDCardImageTops2.length>0" :imgs="detailForm.IDCardTops" :ids="detailForm.IDCardImageTops2"></showImages>
						<div v-if="detailForm.IDCardImageTops&&detailForm.IDCardImageTops.SmallPath">
							<img :src="$store.state.imgUrl + detailForm.IDCardImageTops.Id" class="avatar">
						</div>
					</el-form-item>
					<el-form-item label="身份证照(后):" laber-width="120px">
						<showImages v-if="detailForm.IDCardImageAfters2&&detailForm.IDCardImageAfters2.length>0" :imgs="detailForm.IDCardAfters" :ids="detailForm.IDCardImageAfters2"></showImages>
						<div v-if="detailForm.IDCardImageAfters&&detailForm.IDCardImageAfters.SmallPath">
							<img :src="$store.state.imgUrl + detailForm.IDCardImageAfters.Id" class="avatar">
						</div>
					</el-form-item> 
					-->
					
				</el-form>
				</el-scrollbar>
		</el-drawer>
	</div>
</template>
<script>
import { GetAllFellList } from '../../api/user.js';
import { GetFellDetail } from '@/api/Examine'
import showImages from '@/components/showImage'
export default {
	name: 'operator',
	data() {
		return {
			keywordType:'1',
			key: '', // 搜索关键字
			loading: false, // 数据是否处于加载状态
			tableData: [], // 表格数据
			total: 0, // 数据总数
			currentPage: 1, // 当前页数
			pageSize: 10, // 当前查询数据个数
			detailModal:false,//详情
			detailForm:{},//详情数据
		};
	},
	components:{showImages},
	mounted() {
		this.getList();
	},
	methods: {
		// 分页查询
		handleSizeChange(e) {
			this.pageSize = e;
			this.getList();
		},
		handleCurrentChange(e) {
			this.currentPage = e;
			this.getList();
		},
		/*获取所有数据列表 */
		async getList() {
			this.loading = true
			try {
				let params = {
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					keyword: this.key,
					keywordType:this.keywordType
				};
				let { data } = await GetAllFellList(params);
				if (data.state === 1) {
					this.tableData = data.data.lis;
					this.total = data.data.count;
					this.loading = false
				} else {
					this.loading = false
					this.$message.error(data.msg);
				}
			} catch (err) {
				this.loading = false
				this.$message.error("获取列表失败,请稍后重试!");
			}
		},

		goDetail(row,type){
			if(type==1){
				let params = {
					id:row.id,
				}
				GetFellDetail(params).then(res=>{
					if(res.data.state==1){
						this.detailForm = JSON.parse(res.data.data)
						if(this.detailForm.IDCardImageTops2.length>0){
							let arr  = []
							this.detailForm.IDCardImageTops2.forEach(item=>{
								arr.push(this.$store.state.imgUrl + item.id)
							})
							this.detailForm.IDCardTops = arr
						}
						
						if(this.detailForm.IDCardImageAfters2){
							let arr2 = []
							this.detailForm.IDCardImageAfters2.forEach(item=>{
								arr2.push(this.$store.state.imgUrl + item.id)
							})
							this.detailForm.IDCardAfters = arr2
						}
						this.detailModal=true
					}else{
						this.$message.error(res.data.msg)
					}
				})
			}else{
				this.$router.push({
				    name:"fellAreaManage",
				    params:{id:row.id,name:row.name}
				}) 
			}	
		}
	}
};
</script>
<style lang="less" scoped>
.operator {
	height: 100%;
	.search {
	  padding: 15px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.title {
			font-size: 20px;
			font-weight: bold;
		}
		.condition {
			display: flex;
			align-items: center;
			margin-right: 20px;
		}
	  .el-input {
	    width:40%;
			margin-right:30px ;
	  }
		// .el-select {
		// 	 width: 150px;
		// }
	}
	.table {
		padding: 0px 15px;
	}
	.page {
		text-align: center;
	}
	/deep/ .el-dialog__header {
		padding: 10px;
		background-color: #5bacf0;
	}
	/deep/ .el-dialog__title {
		color: #fff;
	}
	/deep/ .el-dialog__body {
		padding: 15px;
	}
	/deep/ .el-dialog__footer {
		padding: 0px 10px 10px 10px;
	}
	/deep/ .el-drawer {
		top: 60px!important;
		height: 100%!important;
	}
	/deep/.el-button--small, .el-button--small.is-round {
		padding: 8px!important;
	}
	
}
</style>
